export const GET_ALL_PESQUISAS_SATISFACAO = 'GET_ALL_PESQUISAS_SATISFACAO'
export const GET_ALL_TAGS = 'GET_ALL_TAGS'
